//product create or update
import product from './contract.json'

export const formTitle = (isCreated = true, isUpper = true) => {
    const title = isCreated ? 'Создать договор' : 'Инфо о Договоре'
    return isUpper ? title.toUpperCase() : title
}

export const formKeys = product


//companies
import {keys, buttons} from './contracts.json'

export const tableTitle = (isUpper = true) => isUpper ? 'Договора'.toUpperCase() : 'Договора'


export const tableKeys = (isUpper = true) => isUpper ? keys.map(key => {
    return {
        value: key.value,
        text: key.text.toUpperCase()
    }
}) : keys

export const tableButtons = (isUpper = true) => isUpper ? buttons.map(btn => {
    return {
        route: btn.route,
        name: btn.name.toUpperCase()
    }
}) : buttons
